module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/91935ca9beb1c941b4acfae2115578cc.png";